var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 15.8354C18.25 18.0688 17.5274 19.6489 16.4362 20.6742C15.3364 21.7074 13.7842 22.25 12 22.25C10.2158 22.25 8.6636 21.7074 7.56379 20.6742C6.47255 19.6489 5.75 18.0688 5.75 15.8354V8.75H18.25V15.8354Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 7.23077C7.75 5.04163 8.12955 3.70151 8.77857 2.90853C9.39635 2.15373 10.3829 1.75 12 1.75C13.617 1.75 14.6036 2.15373 15.2214 2.90853C15.8704 3.70151 16.25 5.04163 16.25 7.23076L16.25 8.75L7.75 8.75L7.75 7.23077Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V17",
    stroke: "black",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/password.29a456433bf457c6da5aa0e16d021776.svg";